import type { Logger } from '#src/assets/lib/logger.ts'

const STORAGE_KEY = 'lenus_visitor_id'

function getSessionVisitorId(): string {
  if (!window.__lenusSessionVisitorId) {
    window.__lenusSessionVisitorId = 'vis_session_' + crypto.randomUUID()
  }

  return window.__lenusSessionVisitorId
}

export function getVisitorId(log: Logger['log']): string {
  let visitorId: string | null = null

  if (typeof localStorage !== 'undefined') {
    try {
      visitorId = localStorage.getItem(STORAGE_KEY)

      if (!visitorId) {
        visitorId = 'vis_' + crypto.randomUUID()
        localStorage.setItem(STORAGE_KEY, visitorId)
      }
    } catch (error) {
      log('localStorage unavailable', (error as Error).message)
      visitorId = getSessionVisitorId()
    }
  } else {
    visitorId = getSessionVisitorId()
  }

  if (!visitorId) {
    throw new Error('Failed to get visitor ID')
  }

  return visitorId
}
